import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleTaobaoGuide() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">Инструкция</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Как покупать на TaoBao через Spreadsheet: полный гид 2026
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Пошаговая инструкция по заказу товаров с TaoBao через систему таблиц YOYBUY. От выбора товара до получения посылки.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 8 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20showing%20shopping%20app%20interface%20with%20colorful%20product%20images%20floating%20around%20in%20AR%20holographic%20style%2C%20modern%20tech%20lifestyle%2C%20futuristic%20shopping%20concept%2C%20bright%20clean%20white%20background%20with%20vibrant%20product%20holograms%2C%20innovative%20ecommerce%20photography%2C%20digital%20retail%20future%2C%20soft%20blue%20and%20coral%20accents&width=1200&height=600&seq=yoybuy-art-taobao-hero&orientation=landscape"
              alt="TaoBao покупки гид"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Почему TaoBao?</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                TaoBao — крупнейшая торговая площадка Китая с миллионами товаров по ценам производителей. Здесь можно найти практически всё: от одежды и обуви до электроники и товаров для дома. Однако для покупателей из других стран процесс заказа с TaoBao может быть сложным из-за языкового барьера, сложностей с оплатой и доставкой.
              </p>
              <p className="text-base text-foreground-600 leading-relaxed">
                <strong>YOYBUY Spreadsheet</strong> решает эту проблему: все товары уже отобраны и структурированы в удобных таблицах на <Link to="/" className="text-accent-500 hover:underline">YOYBUY.PRO</Link>. Вам не нужно разбираться в китайском интерфейсе TaoBao — просто выберите категорию и смотрите готовую подборку.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Пошаговая инструкция</h2>
              <ol className="space-y-5">
                {[
                  { step: '1', title: 'Выберите категорию на YOYBUY.PRO', text: 'Зайдите на сайт YOYBUY.PRO и выберите интересующую категорию из 14 доступных: обувь, одежда, аксессуары, сумки и другие. Система автоматически перенаправит вас к таблице с товарами.' },
                  { step: '2', title: 'Изучите таблицу товаров', text: 'В таблице на Kaspreadsheet вы увидите все доступные товары выбранной категории с TaoBao: фото, цены, размеры, цвета и наличие. Все данные актуальны и обновляются ежедневно.' },
                  { step: '3', title: 'Сравните и выберите', text: 'Используйте фильтры таблицы для сортировки по цене, размеру или другим параметрам. Сравните несколько вариантов и выберите лучший.' },
                  { step: '4', title: 'Оформите заказ', text: 'Следуйте инструкциям на платформе Kaspreadsheet для оформления заказа. Выберите способ доставки и оплаты, подходящий для вашего региона.' },
                  { step: '5', title: 'Отслеживайте доставку', text: 'После оформления заказа вы получите трек-номер для отслеживания посылки. Сроки доставки зависят от выбранного способа и вашего региона.' },
                ].map((item) => (
                  <li key={item.step} className="flex gap-4">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">{item.step}</span>
                    <div>
                      <h4 className="text-base font-semibold text-foreground-800">{item.title}</h4>
                      <p className="text-sm text-foreground-500 mt-1">{item.text}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Часто задаваемые вопросы</h2>
              <div className="space-y-4">
                {[
                  { q: 'Нужно ли знать китайский язык?', a: 'Нет. YOYBUY Spreadsheet предоставляет всю информацию на понятном языке. Таблицы содержат переведённые описания товаров, цены в удобном формате и понятные фильтры.' },
                  { q: 'Какие способы оплаты доступны?', a: 'Доступные способы оплаты зависят от платформы Kaspreadsheet. Обычно это банковские карты, электронные кошельки и международные переводы. Детали уточняйте при оформлении заказа.' },
                  { q: 'Сколько времени занимает доставка?', a: 'Сроки доставки варьируются от 7 до 30 дней в зависимости от выбранного способа: экспресс-доставка (7-14 дней), стандартная (14-21 день) или экономичная (21-30 дней). Точные сроки указаны в таблице для каждого товара.' },
                ].map((faq, i) => (
                  <div key={i} className="p-5 bg-background-100 rounded-2xl">
                    <h4 className="text-base font-semibold text-foreground-800 mb-2">{faq.q}</h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                ))}
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Начните покупки на TaoBao</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                Выбирайте товары из 14 категорий и заказывайте через YOYBUY Spreadsheet без лишних сложностей.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Как покупать на TaoBao через Spreadsheet: полный гид 2026",
          "description": "Пошаговая инструкция по заказу товаров с TaoBao через систему таблиц YOYBUY. От выбора до получения.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/taobao-spreadsheet-guide`}
        })}
      </script>
    </main>
  );
}